<mat-card>
  <mat-card-header>
    <mat-card-title i18n="@@email-template-parameters.tokens">
      Replaceable Tokens
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="replacable-parameters-notice">
      <span>
        <p>The template below supports <em>replacable tokens</em>, which will be replaced when generating the email.</p>
        <p>Supported tokens are:</p>
        <p *ngFor="let param of replacementParameters">

          <button mat-raised-button class="action-button action-button-tiny" color="primary"
            (click)="copyToClipboard(paramToken(param))">Copy to Clipboard</button>
          &nbsp;
          <strong>{{ paramToken(param) }}</strong>:
          {{param.description}}
          <span *ngIf="param.value">. Example: <strong>{{param.value}}</strong></span>

        </p>
      </span>
    </div>
  </mat-card-content>
</mat-card>